const PRODUCT_TYPES = [
  { label: 'Hardware', value: 'hardware' },
  { label: 'Software', value: 'software' },
  { label: 'Other', value: 'other' },
]

export function getProductTypes() {
  return PRODUCT_TYPES
}

export default PRODUCT_TYPES
export const productTypeChoices = PRODUCT_TYPES
